export default __webpack_public_path__ + "static/media/EnogenLogin.d2ddd4e9.png";